import axiosClient from ".";
class GetTrendsAPI {
  static get_trends() {
    return axiosClient.get("/bet_trends.json");
  }
}
export default GetTrendsAPI;
